<!-- <app-match-game *ngIf="kind == 'match'" style="position: absolute; width: 100vw;" id="matchGame"></app-match-game> -->
<!-- <app-trivia-game  style="position: absolute; width: 100vw;"></app-trivia-game> -->
<!-- <lottie-animation-view   
*ngIf="true"              
[options]="c5"
(animCreated)="handleAnimation($event)"> </lottie-animation-view> -->
<lottie-player style="position: absolute;" src="../../assets/anim/TrainBg2.json" background="transparent" speed="1" loop
  autoplay>
</lottie-player>

<lottie-player style="position: absolute; z-index: 9;" (click)="zBirds($event)" id="birds-anim"
  src="../../assets/anim/Birds.json" background="transparent" speed="1" loop autoplay>
</lottie-player>

<lottie-player style="position: absolute; z-index: 3;" src="../../assets/anim/Sun.json" background="transparent"
  speed="1" autoplay>
</lottie-player>

<!-- <lottie-player style="position: absolute; z-index: 99;" src="../../assets/anim/Logo1.json"  background="transparent" speed="1" autoplay >
</lottie-player> -->


<div class="page" (click)="chooseSection($event)">
  <h1>מרכז המשחקים</h1>
  <div class="game-container match">
    <div id="opacity-match" class="opacity"></div>
    <div class="choose-logo-cont">
      <lottie-player id="logo-match-anim" src="../../assets/anim/Logo1.json"
        background="transparent" speed="4">
      </lottie-player>
    </div>
    <!-- <div id="match-logo" class="logo match-logo pic"></div> -->
    <div id="play-container-match" class="play-container">
      <!-- <div class="section right" routerLink="/match-game/mitanim" (click)="changeGame('match_mitanim', $event)">
        <div class="arrow pic rotate"></div>
        <div class="info">
          <h2>לחטיבת מטענים</h2>
          <div class="flex-center">
            <div class="award pic"></div>
            <h3>{{champs[0].name}}</h3>
          </div>
        </div>
      </div> -->
      <!-- <div class="line"></div> -->
      <div class="section left" routerLink="/match-game/nosaim" (click)="changeGame('match_nosaim', $event)">
        <div class="info">
          <h2>לחטיבת נוסעים</h2>
          <div class="flex-center">
            <div class="award pic"></div>
            <h3>{{champs[1].name}}</h3>
          </div>
        </div>
        <!-- <div class="arrow pic"></div> -->
      </div>
    </div>
  </div>
  <div class="game-container trivia">
    <div id="opacity-trivia" class="opacity"></div>
    <div class="choose-logo-cont">
    <lottie-player id="logo-trivia-anim" src="../../assets/anim/Logo2.json"
      background="transparent" speed="4">
    </lottie-player>
    </div>
    <!-- <div id="trivia-logo" class="logo trivia-logo pic"></div> -->
    <div id="play-container-trivia" class="play-container">
      <!-- <div class="section right" routerLink="/trivia-game/mitanim" (click)="changeGame('trivia_mitanim', $event)">
        <div class="arrow pic rotate"></div>
        <div class="info">
          <h2>לחטיבת מטענים</h2>
          <div class="flex-center">
            <div class="award pic"></div>
            <h3>{{champs[2].name}}</h3>
          </div>
        </div>
      </div> -->
      <!-- <div class="line"></div> -->
      <div class="section left" routerLink="/trivia-game/nosaim" (click)="changeGame('trivia_nosaim', $event)">
        <div class="info">
          <h2>לחטיבת נוסעים</h2>
          <div class="flex-center">
            <div class="award pic"></div>
            <h3>{{champs[3].name}}</h3>
          </div>
        </div>
        <!-- <div class="arrow pic"></div> -->
      </div>
    </div>
  </div>
</div>